import { gql } from 'apollo-boost';

export const EXTRACT_CAROUSEL_ARTIFACTS = gql`
    mutation($data: ExtractCarouselOcrInput!) {
        extractCarouselArtifacts(data: $data) {
            id
            entities {
                type
                name
                confidence
                artifactId
                enrichment {
                    image
                    width
                    height
                    aspect_ratio
                    description
                    year
                    url
                    source
                }
            }
        }
    }
`;
